import MessageBox from './messageBox.vue'
const createMessageboxContructor = (Vue, Config) => {
  const MessageBoxContructor = Vue.extend(Config)
  MessageBoxContructor.prototype.onclose = function () {

  }
  MessageBoxContructor.prototype.destroyeInstance = function () {
    const ontransitionend = () => {
      this.$destroy(true)
      this.$el.removeEventListener('transitionend', ontransitionend)
      this.$el.parentNode.removeChild(this.$el)
    }
    this.$el.addEventListener('transitionend', ontransitionend)
  }
  return MessageBoxContructor
}

export default {
  install(Vue, options) {
    const MessageBoxContructor = createMessageboxContructor(Vue, MessageBox)

    Vue.prototype.$alert = function (options) {
      options = {
        $type: '$alert',
        ...options
      }
      return this.$messageBox(options)
    }

    Vue.prototype.$confirm = function (options) {
      options = {
        $type: '$confirm',
        ...options
      }
      return this.$messageBox(options)
    }

    Vue.prototype.$messageBox = (options) => {
      const $instance = new MessageBoxContructor({
        el: document.createElement('div'),
        propsData: options
      })
      document.body.appendChild($instance.$el)
      Vue.nextTick(() => {
        $instance.doopen()
      })

      return new Promise((resolve, reject) => {
        console.log('[instance]', $instance)
        $instance.$once('closeDialog', (action) => {
          $instance.destroyeInstance()
          if (action === 'confirm') {
            resolve()
          } else {
            reject(new Error(`action:${action}`))
          }
        })
      })
    }
  }
}
